const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SSN[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond1[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis1[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond2[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis2[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond3[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis3[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond4[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis4[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond5[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis4[1]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond7[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis8[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond8[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis9[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond80[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis11[2]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond9[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis11[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond10[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis11[1]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond11[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis14[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond13[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis15[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond14[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis15[5]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond15[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis19[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond15[1]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis19[1]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond13[1]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis15[1]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond13[2]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis15[2]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond13[3]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis15[3]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].skincond13[4]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis15[4]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].DIAGNOSIS20[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis20[0]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].DIAGNOSIS21[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis21[0]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].DIAGNOSIS22[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis22[0]",
        },     
    ]

}

export default ssn ;